import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SubMenuContentProps } from '../models/MenuContentProps';
import { StyledAppSubMenuItem } from './AppMenuItem.styles';

export const AppSubMenuItem = ({ item }: { item: SubMenuContentProps }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    setIsSelected(item.path === pathname);
  }, [pathname, item]);

  return (
    <StyledAppSubMenuItem
      $isSelected={isSelected}
      onClick={() =>
        navigate(item.path, {
          state: {
            fromMenu: true,
          },
        })
      }
    >
      <span>{item.text}</span>
    </StyledAppSubMenuItem>
  );
};
